// extracted by mini-css-extract-plugin
export default {"self":"AddMassOffering-module--self---GDyh","subtitle":"AddMassOffering-module--subtitle--1amez"};